import { useTranslation } from '@framework/i18n';
import React from 'react';
import type { IWidgetComponentProps } from '~packages/engine/src/schema/widgets/IWidgetType';
import { RichTextAdvancedRender } from '../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender';
import { useWidgetVisibility } from '../../../hooks/useWidgetVisibility';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps';
import type { IDividerWidget } from './IDividerWidget';
import { TitleDivider } from './style/TitleDivider';

export interface IDividerWidgetComponentProps
  extends IWidgetComponentProps<IDividerWidget> {}

export function DividerWidgetComponent(props: IDividerWidgetComponentProps) {
  const options = getWidgetProps(props);

  const { t } = useTranslation();
  const visible = useWidgetVisibility(props.widget, options);

  if (!visible) return null;

  return (
    <TitleDivider>
      <RichTextAdvancedRender
        hasCustomFont
        text={
          props.widget.title ??
          (options.preview
            ? [
                {
                  type: 'text',
                  text: t(
                    'divider-widget.new-divider-title',
                    'Nuovo titolo divisore',
                  ),
                },
              ]
            : [])
        }
      />
    </TitleDivider>
  );
}
